export default function formatSVG(svg: string) {
  return `url("data:image/svg+xml;base64,${btoa(svg)}")`;
}
